import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_simulator.gif';
import type { ItemSimulator } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';

class SimulatorList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Simulator';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemSimulator;
        const authors = item.developer.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {authors}
            </>
        );
    }
}

export default SimulatorList;
